/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Cta_Start_SellingInputs */

const en_home_cta_start_selling = /** @type {(inputs: Home_Cta_Start_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Selling Free`)
};

const es_home_cta_start_selling = /** @type {(inputs: Home_Cta_Start_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza a vender gratis`)
};

const fr_home_cta_start_selling = /** @type {(inputs: Home_Cta_Start_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer à vendre gratuitement`)
};

const de_home_cta_start_selling = /** @type {(inputs: Home_Cta_Start_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos verkaufen`)
};

const ja_home_cta_start_selling = /** @type {(inputs: Home_Cta_Start_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料で販売を始める`)
};

const zh_home_cta_start_selling = /** @type {(inputs: Home_Cta_Start_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费开始销售`)
};

const ar_home_cta_start_selling = /** @type {(inputs: Home_Cta_Start_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابدأ البيع مجانًا`)
};

const id_home_cta_start_selling = /** @type {(inputs: Home_Cta_Start_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai Berjualan Gratis`)
};

const it_home_cta_start_selling = /** @type {(inputs: Home_Cta_Start_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia a Vendere Gratis`)
};

const ru_home_cta_start_selling = /** @type {(inputs: Home_Cta_Start_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начать продавать бесплатно`)
};

const pt_home_cta_start_selling = /** @type {(inputs: Home_Cta_Start_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comece a Vender Grátis`)
};

const ko_home_cta_start_selling = /** @type {(inputs: Home_Cta_Start_SellingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료로 판매 시작하기`)
};

/**
* | output |
* | --- |
* | "Start Selling Free" |
*
* @param {Home_Cta_Start_SellingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const home_cta_start_selling = /** @type {((inputs?: Home_Cta_Start_SellingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Cta_Start_SellingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_cta_start_selling(inputs)
	if (locale === "es") return es_home_cta_start_selling(inputs)
	if (locale === "fr") return fr_home_cta_start_selling(inputs)
	if (locale === "de") return de_home_cta_start_selling(inputs)
	if (locale === "ja") return ja_home_cta_start_selling(inputs)
	if (locale === "zh") return zh_home_cta_start_selling(inputs)
	if (locale === "ar") return ar_home_cta_start_selling(inputs)
	if (locale === "id") return id_home_cta_start_selling(inputs)
	if (locale === "it") return it_home_cta_start_selling(inputs)
	if (locale === "ru") return ru_home_cta_start_selling(inputs)
	if (locale === "pt") return pt_home_cta_start_selling(inputs)
	return ko_home_cta_start_selling(inputs)
});